module.exports = __webpack_public_path__ + "static/media/img_give_back@3x.97edb655.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_give_back@3x.webp
// module id = 816
// module chunks = 0